<div class="bg-white px-[1.25rem]">
  <div
    class="w-full max-w-[1400px] flex justify-between items-center mx-auto relative"
  >
    <div class="flex justify-between items-center">
      <ra-title class="mr-6 max-[1350px]:mr-2" [isDemo]="false"></ra-title>
      <ra-category [amountCol]="4" class="mr-6"></ra-category>
      <div class="flex">
        <ra-header-service-menu
          class="mr-8 max-[1170px]:mr-4"
          label="Коммерческая недвижимость"
          [links]="creLinks"
        ></ra-header-service-menu>
        <ra-header-service-menu
          class="mr-8 max-[1170px]:mr-4"
          label="Транспорт"
          [links]="transportLinks"
        ></ra-header-service-menu>
        <ra-header-service-menu
          label="Спецтехника"
          [links]="specTransportLinks"
        ></ra-header-service-menu>
      </div>
    </div>
<!--    <div class="flex justify-between items-center">-->
<!--      <ra-user-space />-->
<!--    </div>-->
  </div>
</div>
